import { Trans, useTranslation } from 'next-i18next/pages';
import { Checkbox } from '@pkgs/components/components/Checkbox/Checkbox';
import { type Listing } from '@pkgs/api';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useExposeTracking } from '@/hooks/useExposeTracking';
import { ExpandableLabel } from '@/components/property-expose/ExpandableLabel/ExpandableLabel';

import styles from '../ContactForm.module.css';

export const CountryConsent = ({
  countryConsentRef,
  listing,
}: {
  countryConsentRef: React.RefObject<HTMLDivElement>;
  listing: Listing;
}) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const { trackExposeUserInteractionEvent } = useExposeTracking();

  return (
    <Checkbox
      className={styles.checkbox}
      name="marketingConsent"
      aria-label={t('search.contact.form.label.countryConsent.checkboxLabel')}
      size="s"
      onChange={() => trackExposeUserInteractionEvent({ elementId: 'request-expose_consent_checkbox-country' })}
      label={
        <>
          <ExpandableLabel
            className={styles.expandableMarketingConsent}
            maxLines={3}
            data-testid="expose-contact-form_country-consent_expandable-label"
          >
            <div ref={countryConsentRef}>
              <Trans
                i18nKey="search.contact.form.label.countryConsent"
                t={t}
                values={{ legalEntity: listing.countryConsent?.legalEntity }}
                components={[
                  <a key="office-name" href={listing.countryConsent?.imprintUrl} target="_blank" rel="noreferrer" />,
                  <a key="privacy-link" href={listing.countryConsent?.dataPrivacyUrl} target="_blank" rel="noreferrer" />,
                ]}
              />
            </div>
          </ExpandableLabel>
        </>
      }
    />
  );
};
